import { gql } from "graphql-request";

const SERVER_DELETE_SYNDICATO = gql`
  mutation SERVER_DeleteSyndicate($id: ID!) {
  deleteSyndicate(id: $id)
}
`;
export default SERVER_DELETE_SYNDICATO;
